import React, { useContext, useEffect, useRef, useState } from 'react'
import { AuthContext } from '../../../../Base/Context/AuthContext/AuthContext';
import { ConfigContext } from '../../../../Base/Context/ConfigContext/ConfigContext';
import { chageEstadoRangos, getRangosDocumentos } from '../../../../API/Finanzas/RegistroContable/RangosDocumentosRequest';
import { Toast } from 'primereact/toast';
import Card from '../../../../Base/Components/Card/Card';
import AgGrid from '../../../../Base/Components/Tables/AgGrid/AgGrid';
import Loader from '../../../../Base/Components/Loader/Loader';
import { Button } from 'primereact/button';
import { getLabel } from '../../../../Base/Services/Language/LanguageService';
import { baseLang } from '../../../../Base/Lang/BaseLang';
import RangosCRUD from './RangosCRUD';
import { setTitlePage } from '../../../../Base/Services/Config/ConfigService';
import { Dropdown } from 'primereact/dropdown';
import { getEstadosCategory } from '../../../../API/Global/Status/StatusRequests';
import { confirmDialog } from 'primereact/confirmdialog';
import { toastShow } from '../../../../Base/Services/ToastService';

const RangosScreen = () => {
    const { userAuth } = useContext(AuthContext);
    const esAdminFinanzas = [1,36].includes(userAuth?.IdRol);

    const { config } = useContext(ConfigContext);
    const toast = useRef(null);

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [showDialog, setShowDialog] = useState(false);
    const [estados, setEstados] = useState([]);

    const [selected, setSelected] = useState(null);

    const getInfo = async () =>{
      setLoading(true);
      let result = await getRangosDocumentos();
      setData(result);
      const estadosTempo = await getEstadosCategory('RangoDocumentos')
      setEstados(estadosTempo)
      setLoading(false);
    }

    const ingresarEditar = (data) =>{
      if(esAdminFinanzas){
        setSelected(data)
        setShowDialog(true)
      }
    }

    const changeEstado = ({ data, api }) => {
      return (
        <div>
          <Dropdown
            value={estados.filter((e) => e.IdStatus === data.IdStatus)[0]}
            options={estados}
            optionLabel="StatusName"
            filter
            filterBy="StatusName"
            style={{ width: "100%" }}
            onChange={(e) => {
              let changes = [];
              console.log(selected);
              if (selected?.length > 0) {
                changes = selected.map((item) => {
                  return {
                    IdRango: item.IdRango,
                    IdStatus: e.value.IdStatus,
                    StatusName: e.value.StatusName,
                  };
                });
              } else {
                changes.push({
                  IdRango: data.IdRango,
                  IdStatus: e.value.IdStatus,
                  StatusName: e.value.StatusName,
                });
              }
              confirmDialog({
                message: `¿Cambiar a estado ${e.value.StatusName} a ${changes?.length} ${changes?.length > 1 ? 'Rangos' : 'Rango'}?`,
                header: "Confirmación",
                icon: "pi pi-exclamation-triangle",
                accept: async () => {
                  let IdRangos = changes.map((item) => item.IdRango);
                  cambiarEstado(e.value.IdStatus, IdRangos.toString());
                  getInfo();
                  api.stopEditing();
                },
                reject: () => {},
              });
            }}
          />
        </div>
      );
    };
  
    const cambiarEstado = async (IdStatus, IdRangos) => {
      const result = await chageEstadoRangos({ IdStatus, IdRangos });
      toastShow(toast, "success", "Actualizado", "Estado cambiado exitosamente");
      setSelected([]);
    };

    const columns = [
      {
        header: "ID",
        headerEn: "ID",
        field: "IdRango",
        className: "XXsmall",
        frozen: true,
        hidden: userAuth?.IdRol === 1,
      },
      {
        field: "FechaCreacion",
        header: "Fecha Creación",
        headerEn: "Date Create",
        className: "medium",
        Format: "DateTime",
        frozen: true,
      },
      {
        field: "StatusName",
        header: "Estado",
        Sumary: "count",
        headerEn: "Status",
        className: "Xsmall",
        body: (rowData) => ({
          ID: rowData.IdStatus,
          Estado: rowData.StatusName,
        }),
        Format: "Estado",
        frozen: true,
        cellEditor: changeEstado,
        editable: userAuth?.IdRol === 1,
      },
      {
        header: "Tipo Rango",
        headerEn: "Type Range",
        field: "Type",
        className: "large",
      },
      {
        header: "Prefijo",
        headerEn: "Prefix",
        field: "Prefijo",
        className: "Xlarge",
        onCellDoubleClicked: ({ data }) => {
          ingresarEditar(data);
        },
      },
      {
        header: "Rango Inicial",
        headerEn: "Prefix",
        field: "RangoInicial",
        className: "large",
      },
      {
        header: "Rango Final",
        headerEn: "Prefix",
        field: "RangoFinal",
        className: "large",
      },
      {
        header: "Cantidad",
        headerEn: "Amount",
        field: "Count",
        className: "Xsmall",
      },
      {
        field: "FechaEmision",
        header: "Fecha Emisión",
        headerEn: "Issue Date",
        className: "medium",
        Format: "DateTime",
      },
      {
        field: "FechaVencido",
        header: "Fecha Vencimiento",
        headerEn: "Expiration Date",
        className: "medium",
        Format: "DateTime",
      },
      {
        header: "Comentario",
        headerEn: "Comment",
        field: "Comentarios",
        className: "XXXXlarge",
      },
      {
        header: "No. Exoneración",
        headerEn: "No. Exoneración",
        field: "NoExoneracion",
        className: "small",
      },
      {
        header: "Usuario creación",
        headerEn: "User Created",
        field: "UserName",
        className: "small",
      },
      {
        field: "IdRango",
        header: "",
        Format: "Botones",
        frozen: true,
        alignFrozen: "right",
        filter: false,
        hidden: esAdminFinanzas,
        Botones: [
          {
            icon: "pi pi-pencil",
            tooltip: "Editar",
            onClick: (rowData) => {
              if (rowData?.IdRango && rowData?.IdStatus !== 85) {
                //Abrir Dialog cuando IdStatus sea distincto a 85 (Inactivo)
                setSelected(rowData);
                setShowDialog(true);
              }
            },
            tooltipOptions: {
              position: "right",
            },
          },
        ],
      },
    ];

    const table = {
      Columns: columns,
      Data: data,
      showModal: () => {},
    };

    useEffect(()=>{
      getInfo();
      setTitlePage(getLabel(baseLang, "Rangos", config.language));
    },[])

  return (
    <div>
      <Toast ref={toast} />
      <Card
        style={{ marginTop: 25 }}
        titulo={
          <div className="botones flex-wrap flex-wrap">
            <h2>{getLabel(baseLang, "Rangos", config.language)}</h2>
            <Button
              icon="pi pi-refresh"
              tooltip="Buscar"
              onClick={() => getInfo()}
            />

            {esAdminFinanzas && (
              <Button
                icon="pi pi-plus"
                tooltip="Nuevo"
                onClick={(e) => {
                  setShowDialog(true);
                  setSelected(null);
                }}
              />
            )}
          </div>
        }
        contenido={
          <div>
            <Loader loading={loading} />
            <div style={{ height: "86vh" }}>
              <AgGrid table={table} />
            </div>
          </div>
        }
      />

      {showDialog && (
        <RangosCRUD
          showDialog={showDialog}
          selected={selected}
          setSelected={setSelected}
          setShowDialog={setShowDialog}
          getInfo={getInfo}
        />
      )}
    </div>
  );
}

export default RangosScreen